
import { useAuthState } from "./useAuthState";
import { useAuthentication } from "./useAuthentication";
import { usePasswordReset } from "./usePasswordReset";

export const useAuthFlow = () => {
  const {
    email,
    setEmail,
    password,
    setPassword,
    username,
    setUsername,
    lastName,
    setLastName,
    firstName,
    setFirstName,
    residenceCountry,
    setResidenceCountry,
    loading,
    setLoading,
    isSignUp,
    setIsSignUp
  } = useAuthState();

  const { handleAuth, handleResendConfirmation } = useAuthentication(
    email,
    password,
    username,
    lastName,
    firstName,
    residenceCountry,
    isSignUp,
    setLoading
  );

  const { handleResetPassword } = usePasswordReset(email, setLoading);

  return {
    email,
    setEmail,
    password,
    setPassword,
    username,
    setUsername,
    lastName,
    setLastName,
    firstName,
    setFirstName,
    residenceCountry,
    setResidenceCountry,
    loading,
    isSignUp,
    setIsSignUp,
    handleAuth,
    handleResendConfirmation,
    handleResetPassword
  };
};
